const styles = ({ typography }) => ({
  container: {
    marginBottom: '70px',
  },
});

export default styles;
  